import React from "react";
import { useAuth } from "../auth/contexts/AuthProvider";
import { useSyncUserProfile } from "./useSyncUserProfile";

export function AuthProfileSync({ children }: { children: React.ReactNode }) {
  const { isAuthenticated } = useAuth();
  useSyncUserProfile(isAuthenticated);
  return <>{children}</>;
}
